import { Injectable } from '@angular/core';
import { config } from '@core/interfaces/api_baseurl';
import {
  BehaviorSubject,
  Observable,
  of,
  switchMap,
  tap,
} from 'rxjs';
import { DashCount, KycStage } from './dashboard.types';
import { ApiService } from '@core/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  private _kycStatus: BehaviorSubject<KycStage | null> =
    new BehaviorSubject<KycStage | null>(null);
  private _dashboardCount: BehaviorSubject<DashCount | null> =
    new BehaviorSubject<DashCount | null>(null);
  defBankId: any = 'first';
  defStatus: any = '1';
  _dashboardDetails = new BehaviorSubject<any>(null);

  get kycStatus$(): Observable<KycStage | null> {
    return this._kycStatus.asObservable();
  }

  get kycStatus(): KycStage | null {
    return this._kycStatus.getValue();
  }

  get dashboardCount$(): Observable<DashCount | null> {
    return this._dashboardCount.asObservable();
  }

  get dashboardCount(): DashCount | null {
    return this._dashboardCount.getValue();
  }

  constructor(
    private _ApiService: ApiService,
  ) {
  }

  getKycStatus(): Observable<any> {
    return this._ApiService.post(config.auth.kycStatus).pipe(
      switchMap((r: any) => {
        if (r.statuscode == 200) {
          let { bank_status, kyc_status, account_id }: KycStage = r;
          // let { bank_status, kyc_status, account_id }: KycStage = { bank_status:0, kyc_status:2, account_id:r.account_id };
          this._kycStatus.next({ bank_status, kyc_status, account_id });
        } else {
          r = false;
        }
        return of(r);
      })
    );
  }

  getService() {
    return this._ApiService.post(config.dashboard.service);
  }


  getDashboardCount(bank_id: string): Observable<any> {
    if (bank_id && this.defBankId === bank_id) {
      return this._getDashboardCountFromCache();
    }

    this.defBankId = bank_id;
    const formData = this._createFormData(bank_id);
    return this._ApiService.post(config.verify_dashboard.getAllDashboardStats, formData)
      .pipe(
        switchMap((response: any) => {

          this._dashboardCount.next({
            payoutsData: response.data.payouts,
            va_transactionsData: response.data.va_transactions,
            merchant_upiData: response.data.merchant_upi,
          });
          return of(true);
        }),
        tap(() => {
          // Ensure a return value in all cases
          return of(false);
        })
      );
  }

  // getDashboardCount(bank_id: string, date: string[] = [], status: string = '1'): Observable<any> {
  //   const formData = this._createFormData(date, bank_id, status);
  //   return forkJoin([
  //     this._ApiService.post(config.verify_dashboard.dashboardPayoutCount, formData),
  //     this._ApiService.post(config.verify_dashboard.dashboardVaTxnCount, formData),
  //     this._ApiService.post(config.verify_dashboard.dashboardUpiCount, formData),
  //   ]).pipe(
  //     switchMap((response: any) => {
  //       if (response.code === 200) {
  //         return this._handleSuccessResponse(response.data);
  //       } else {
  //         return of(false);
  //       }
  //     })
  //   );
  // }

  private _getDashboardCountFromCache(): Observable<any> {
    return of(this.dashboardCount).pipe(
      tap(() => {
        this._dashboardCount.next(this.dashboardCount);
      })
    );
  }

  private _createFormData(bank_id: string) {
    const reqBody = {
      bank_id: bank_id,
    };
    return reqBody;

  }

  private _handleSuccessResponse(data: DashCount): Observable<any> {
    const { payoutsData, va_transactionsData, merchant_upiData } = data;

    this._dashboardCount.next({
      payoutsData,
      va_transactionsData,
      merchant_upiData,
    });

    return of(true);
  }

  notificationContent() {
    return this._ApiService.post(
      config.notification.notificationContent
    );
  }
}
